<template>
  <div>
    <!-- layout -->
    <BasicInfo v-if="isShowBasicInfo"
      :isEditMode="isEditMode"
      :isShowSend="isShowSend"
      @clickHeadImg="clickHeadImg"
      @clickSend="$emit('clickSend')"
      @clickAnswer="$emit('clickAnswer')"
      @clickReceive="$emit('clickReceive')"
      @clickAnswerRate="$emit('clickAnswerRate')"
      @clickPv="$emit('clickPv')"
      @clickEdit="$emit('clickEditUser')"
    ></BasicInfo>
    
    <!-- Avatar -->
    <input
      ref="user-upload-avatar"
      class="invisible" type="file" accept="*/*"
      @change="commitUserHeadImage"
    >

    <div style="padding-top:10px"></div>

    <TextModule v-if="isShowUserDesc"
      :data="descData"
      :isEditMode="isEditMode"
      @click="$emit('clickEditUserDesc')"
    >
      <pre class="pre">{{profile}}</pre>
    </TextModule>

    <div
      v-if="isShowUserModule"
      v-for="(row, i) in modules"
      :key="i"
      class="user-module"
    >
      <div v-if="isMobile" class="md-line"></div>
      <TextModule v-if="row.type==='md-text'" :isEditMode="isEditMode" :config="config" :data="row" :index="i" @click="clickEditModule(row, i)"></TextModule>
      <ListModule v-if="row.type==='md-list'" :isEditMode="isEditMode" :config="config" :data="row" :index="i" @click="clickEditModule(row, i)"></ListModule>
      <CaseModule v-if="row.type==='md-case'" :isEditMode="isEditMode" :config="config" :data="row" :index="i" @click="clickEditModule(row, i)" @more="clickModuleMore(row, i)"></CaseModule>
      <TalkModule v-if="row.type==='md-talk'" :isEditMode="isEditMode" :config="config" :data="row" :index="i" @click="clickEditModule(row, i)"></TalkModule>
    </div>

    <public-qa-module></public-qa-module>

    <UserSettingModule
      v-if="isShowUserSetting && isEditMode"
      :isEditMode="isEditMode"
      :data="data"
      @commit="commitUserSetting"
    >
    </UserSettingModule>
    
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BasicInfo from './BasicInfo.vue'
import {
  UserSettingModule,
  TextModule,
  ListModule,
  CaseModule,
  TalkModule,
  PublicQaModule
} from '../module'

export default {
  components: {
    BasicInfo,
    UserSettingModule,
    TextModule,
    ListModule,
    CaseModule,
    TalkModule,
    'public-qa-module': PublicQaModule
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    isShowBasicInfo: {
      type: Boolean,
      default: true
    },
    isShowUserDesc: {
      type: Boolean,
      default: true
    },
    isShowUserModule: {
      type: Boolean,
      default: true
    },
    isShowUserSetting: {
      type: Boolean,
      default: true
    },
    isShowSend: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isLocked: false
    }
  },
  computed: {
    isMobile () { return this.$store.getters.isMobile },
    descData () {
      return {
        name: '个人简介',
        icon: 'icon-pr_phone_icon_profiles_small',
        icon_body: this.isMobile ? null : 'profiles_big'
      }
    },
    ...mapState('api/dartcome', {
      profile: ({card}) => card.profile
    }),
    ...mapGetters('api/dartcome', {
      modules: 'modules'
    })
  },
  methods: {
    clickEditModule (row, i) { this.$emit('clickEditModule', row, i) },
    clickModuleMore (row, i) { console.log('clickModuleMore', row, i) },
    clickHeadImg () {
      if (this.isMobile) return
      if (!this.isEditMode) return
      this.$refs['user-upload-avatar'].click()
    },

    commitUserHeadImage (event) { this.$emit('commitUserHeadImage', event) },
    commitUserSetting (input) { this.$emit('commitUserSetting', input) }
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";
.pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.md-line {
  width: 100%;
  border-top: 1px solid var(--colorGray4);
}
</style>



// WEBPACK FOOTER //
// src/containers/user/User.vue